
import Vue from 'vue'
import Component from 'vue-class-component';
import EventBus from './../../eventBus'
import WellsImport from "@/components/WellImport.vue"
import UserProvisioning from '@/mixins/userProvisioning';
import { Mixins } from 'vue-property-decorator';

@Component({
    components:{
    "wells-import": WellsImport
    }
})
export default class WellsOverview extends Mixins(UserProvisioning){
    //Data
    deletePromptProperty: boolean = false
    loader: boolean = true
    loadingTitle: string = 'Loading...'
    loadingMessage: string = 'Loading Wells'
    successMessage: string = ''
    additionalSuccessMessage = ''
    error: string = ''
    fields: Array<any> = [
        {key: 'selectRow', sortable: false, label: 'Select', thStyle: { width: "60px" }, },
        { key: 'serial', label: 'S/N', sortable: false },
        {key: 'name', sortable: 'true', label: 'Well Name'},
        {key: 'leaseId', sortable: 'true', label: 'Lease ID'},
        {key: 'terrain', sortable: 'true', label: 'Terrain'},
        {key: 'wellType', sortable: 'true', label: 'Fluid Type'},
        // {key: 'wellConfiguration', label: 'Well Profile'},
        {key: 'button', label: "Actions"} 
    ]
    selectedWell: any ={
        id: '',
        name: '',
        status: '',
        wellType: ''
    }
    search: string = ''
    items : Array<any> = []
    activeScreen: string = ''
    selectedRows: {name: string; id: string}[] = []
    selectAll: boolean = false
    showModal:boolean = false
    

    // Methods
    gotoEdit(well_id: number){
        let path: object = {path:'/manage-well/', query:{id:well_id} }
        this.$router.push(path)
    }

    downloadTemplate() {
        this.$store.dispatch('wellsModule/downloadWellsTemplateAction');
    }

    getWellsToDelete () {
        const wellNames = this.selectedRows.map(row => row.name);

        if (wellNames.length <= 3) {
            const lastTwoNames = this.selectedRows.map(row => row.name).splice(-2);
            return `${wellNames.length === 3 ? `${wellNames[0]},` : ''} ${lastTwoNames.join(' and ')}`
        }
        else {
            const firstTwoNames = wellNames.slice(0, 2);
            const remainingCount = wellNames.length - 2;
            return `${firstTwoNames.join(', ')} and ${remainingCount} other${remainingCount > 1 ? 's' : ''} well${remainingCount > 1 ? 's' : ''}`;
        }
    }

    doDelete(bvEvt: any){
        const isMultipleDelete = this.selectedRows.length;
        this.activeScreen = 'loading'
        EventBus.$emit('activeScreen', this.activeScreen)
        this.loadingTitle = 'Deleting'
        this.loadingMessage = 'Deleting '+ this.selectedWell.name
        const payload = isMultipleDelete ? this.selectedRows.map(row => row.id) : [this.selectedWell.id]
        const deletedWells = isMultipleDelete ? this.getWellsToDelete() : '';
        this.deleteWellAction(payload).then(response => {
            this.activeScreen="successNoBack"
            EventBus.$emit('activeScreen', this.activeScreen)
            this.successMessage = isMultipleDelete ? `${deletedWells} Deleted Successfully` : this.selectedWell.name + ' Deleted Successfully'
            this.additionalSuccessMessage = `${isMultipleDelete ? 'These Wells' : 'This Well'} will no longer be available`
            this.deletePromptProperty = false
        },error => {
            this.error=error.response.data.message
            this.activeScreen = 'error'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.deletePromptProperty = false
        })
        
    }

    deleteWellprompt(selected: any){
        this.selectedWell.id = selected.id
        this.selectedWell.name = selected.name
        this.deletePromptProperty = true
    }

    searchValue (e: string) {
        this.search = e
    }

    fetchSequences() {
        return this.$store.dispatch('sequencesModule/fetchSequences')
    }

    toggleSelectAll() {
        if (!this.selectAll) {
            this.selectedRows = this.filteredWells(this.search).map((well: { id: any; name: any; }) => ({id: well.id, name: well.name}))
        } else {
            this.selectedRows = []
        }
    }


    // VUEX ACTIONS
    getWellsAction () {
        return this.$store.dispatch('wellsModule/getWellsAction')
    }

    deleteWellAction (wellIds: string[]) {
        return this.$store.dispatch('wellsModule/deleteWellAction', wellIds)
    }
    // Computed propertied
    get filteredWells () {
        return this.$store.getters['wellsModule/filteredWells']
    }

    get filteredSequences() {
        return this.$store.getters['sequencesModule/filteredRootSequences']
    }

    disableDelete(wellId:any){
        let q = this.filteredSequences('').findIndex((seq:any) => seq.projects.some((project:any)=> project.wellId == wellId))
        if (q >= 0) {
            return true
        }else {
            return false
        }
    }
    
    mounted() {
        if (!this.canWriteSequence) {
            this.fields.shift()
            this.fields.pop()
        }
    }


    // CREATED
    created() {

        if(this.filteredSequences('').length === 0) {
            this.fetchSequences();
        }

        if(this.filteredWells('').length===0){
            this.getWellsAction().then(response=>{
                this.activeScreen = 'main'; 
                EventBus.$emit('activeScreen', this.activeScreen)
                this.loader = false            
            },error => {
                this.activeScreen = 'error'; 
                this.error = error.message
                EventBus.$emit('activeScreen', this.activeScreen)
                this.loader = false   
            })
        } else {
            this.activeScreen = 'main'; 
            EventBus.$emit('activeScreen', this.activeScreen)
            this.loader = false 
        }
    }
    
}
